import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=c79bb8bc&scoped=true"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"
import style0 from "./AccountSetting.vue?vue&type=style&index=0&id=c79bb8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79bb8bc",
  null
  
)

export default component.exports